// 自定义指令插件
const directivesPlugin = {
  install(app) {
    // 指令缓存
    const directivesCache = {}
    
    // 使用 require.context 获取所有指令文件
    const directiveFiles = require.context('.', false, /\.js$/)
    
    directiveFiles.keys().forEach(filePath => {
      // 获取指令配置
      const directiveConfig = directiveFiles(filePath)
      
      // 获取指令名（从文件名中提取）
      const directiveName = filePath
        .replace(/^\.\//, '')  // 去掉开头的 ./
        .replace(/\.\w+$/, '')  // 去掉扩展名
        .replace(/\.\//g, '-')  // 替换路径中的 ./
      
      // 支持两种导出方式
      let directive = directiveConfig.default || directiveConfig[directiveName]
      
      // 如果以上都没有，尝试获取第一个导出
      if (!directive) {
        const keys = Object.keys(directiveConfig)
        if (keys.length > 0) {
          directive = directiveConfig[keys[0]]
        }
      }
      
      if (directive) {
        // 注册指令
        console.log(directiveName, directive,'asdsadad')
        app.directive(directiveName, directive)
        
        // 缓存指令
        directivesCache[directiveName] = directive
        
        // 开发环境输出日志
        if (process.env.NODE_ENV === 'development') {
          // console.log(`✅ 指令 v-${directiveName} 注册成功`)
        }
      }
    })
    
    // 将指令缓存挂载到 app 实例上，方便在组件中访问
    app.config.globalProperties.$directives = directivesCache
    
    // 提供全局方法访问指令
    app.provide('directives', directivesCache)
  }
}

export default directivesPlugin